import { default as aboutjPyrPobcgbMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsPRqJgYtovlMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93AWQwdoispqMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplep6RmFQcThSMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsLEeNkZILdPMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93SCgSLXMwT7Meta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewFxDxeJSNzmMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexKMeOhoQ69jMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93udg2ZbGU5BMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexAexPTHrgx8Meta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93aPrRoO4QiyMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexmAFjunJF9HMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsXI0WmY1mZSMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingspH2rLnTKc8Meta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsAXEU7JNBW4Meta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93WU2c613DaIMeta } from "/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexcW8E1ta5n0Meta } from "/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirm1sscMtZdKFMeta } from "/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirm9lreFnKhCRMeta } from "/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarPF08siiegbMeta } from "/tmp/build_e43f378b/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatSll5i0H50bMeta } from "/tmp/build_e43f378b/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutGTRZmJTElWMeta } from "/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedb61uC56bX0Meta } from "/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersnIY7RN5fRMMeta } from "/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93QjLRzdWVbSMeta } from "/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editVq8DO5iaycMeta } from "/tmp/build_e43f378b/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93Dto1XExhC0Meta } from "/tmp/build_e43f378b/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityRHCVFeJlKPMeta } from "/tmp/build_e43f378b/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93KUD5YcS11MMeta } from "/tmp/build_e43f378b/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93nIaoWPMECkMeta } from "/tmp/build_e43f378b/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardwQWKd2uvEXMeta } from "/tmp/build_e43f378b/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexjweqlpjybtMeta } from "/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutWK5zB2e3nAMeta } from "/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productzaruv8fDGdMeta } from "/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsmUMzRFqLoWMeta } from "/tmp/build_e43f378b/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93JRjqgzya25Meta } from "/tmp/build_e43f378b/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as index9yG4ughAGTMeta } from "/tmp/build_e43f378b/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93f9yWxwQYDJMeta } from "/tmp/build_e43f378b/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93QGL4hWX27IMeta } from "/tmp/build_e43f378b/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as index6IJfbaoxUaMeta } from "/tmp/build_e43f378b/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93qkp2TsypvUMeta } from "/tmp/build_e43f378b/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinKiUY2qRdLlMeta } from "/tmp/build_e43f378b/pages/[studio_url]/join.vue?macro=true";
import { default as loginQFrK1yAWHFMeta } from "/tmp/build_e43f378b/pages/[studio_url]/login.vue?macro=true";
import { default as logoutHc9wm0Av5NMeta } from "/tmp/build_e43f378b/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93JTlAizOp8BMeta } from "/tmp/build_e43f378b/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93sKrsmNeooPMeta } from "/tmp/build_e43f378b/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93YP4z1JDwwcMeta } from "/tmp/build_e43f378b/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesnP0NyeSSfTMeta } from "/tmp/build_e43f378b/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosi3B1jFWheqMeta } from "/tmp/build_e43f378b/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optina9XeYPs4xiMeta } from "/tmp/build_e43f378b/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93fBZpfVNX5qMeta } from "/tmp/build_e43f378b/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexUpoVD9bPY5Meta } from "/tmp/build_e43f378b/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexGllZf06CQdMeta } from "/tmp/build_e43f378b/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as abouts9Irk4NNVLMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentMhn1o26oq1Meta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventstTXMqNF7cCMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93EzBJJlfVo2Meta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleuYxczmTF0nMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsuUxqM2EMnRMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93HE6E24KSgmMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewCfTnJ3ocyNMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index6i0aiJKdDDMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93WfqUaMbKnsMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexvzX1J3k3DoMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93GepfzlWOSDMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index9Q7LTDYIlqMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsGKFBMOX1qkMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsZw385OMPwKMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsUSlJTEBhpYMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93Xn5glodteBMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexSQuATSF23FMeta } from "/tmp/build_e43f378b/pages/[studio_url]/product/index.vue?macro=true";
import { default as index5Qp9RRgSsTMeta } from "/tmp/build_e43f378b/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesaQMeCkKBAiMeta } from "/tmp/build_e43f378b/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsv3zPWzNIaaMeta } from "/tmp/build_e43f378b/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93idJs1LxCyuMeta } from "/tmp/build_e43f378b/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93mMEi0JwqhsMeta } from "/tmp/build_e43f378b/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetD1ObNJ2V6CMeta } from "/tmp/build_e43f378b/pages/[studio_url]/reset.vue?macro=true";
import { default as shopyA9PAPBEe4Meta } from "/tmp/build_e43f378b/pages/[studio_url]/shop.vue?macro=true";
import { default as signupiK6AMmwHUbMeta } from "/tmp/build_e43f378b/pages/[studio_url]/signup.vue?macro=true";
import { default as liveoK8K7dEB92Meta } from "/tmp/build_e43f378b/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipslb19365bWLMeta } from "/tmp/build_e43f378b/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_935PmXpwyttQMeta } from "/tmp/build_e43f378b/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactIg30hovC2CMeta } from "/tmp/build_e43f378b/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full0cXP5NKy6eMeta } from "/tmp/build_e43f378b/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93WU2c613DaIMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93WU2c613DaIMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93WU2c613DaIMeta || {},
    alias: _91product_id_93WU2c613DaIMeta?.alias || [],
    redirect: _91product_id_93WU2c613DaIMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutjPyrPobcgbMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutjPyrPobcgbMeta?.path ?? "about",
    meta: aboutjPyrPobcgbMeta || {},
    alias: aboutjPyrPobcgbMeta?.alias || [],
    redirect: aboutjPyrPobcgbMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsPRqJgYtovlMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsPRqJgYtovlMeta?.path ?? "events",
    meta: eventsPRqJgYtovlMeta || {},
    alias: eventsPRqJgYtovlMeta?.alias || [],
    redirect: eventsPRqJgYtovlMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93AWQwdoispqMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93AWQwdoispqMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93AWQwdoispqMeta || {},
    alias: _91media_id_93AWQwdoispqMeta?.alias || [],
    redirect: _91media_id_93AWQwdoispqMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplep6RmFQcThSMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samplep6RmFQcThSMeta?.path ?? "free-sample",
    meta: free_45samplep6RmFQcThSMeta || {},
    alias: free_45samplep6RmFQcThSMeta?.alias || [],
    redirect: free_45samplep6RmFQcThSMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsLEeNkZILdPMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsLEeNkZILdPMeta?.path ?? "included-products",
    meta: included_45productsLEeNkZILdPMeta || {},
    alias: included_45productsLEeNkZILdPMeta?.alias || [],
    redirect: included_45productsLEeNkZILdPMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93SCgSLXMwT7Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93SCgSLXMwT7Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93SCgSLXMwT7Meta || {},
    alias: _91media_id_93SCgSLXMwT7Meta?.alias || [],
    redirect: _91media_id_93SCgSLXMwT7Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewFxDxeJSNzmMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewFxDxeJSNzmMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewFxDxeJSNzmMeta || {},
    alias: viewFxDxeJSNzmMeta?.alias || [],
    redirect: viewFxDxeJSNzmMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexKMeOhoQ69jMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexKMeOhoQ69jMeta?.path ?? "lessons",
    meta: indexKMeOhoQ69jMeta || {},
    alias: indexKMeOhoQ69jMeta?.alias || [],
    redirect: indexKMeOhoQ69jMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93udg2ZbGU5BMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93udg2ZbGU5BMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93udg2ZbGU5BMeta || {},
    alias: _91media_id_93udg2ZbGU5BMeta?.alias || [],
    redirect: _91media_id_93udg2ZbGU5BMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexAexPTHrgx8Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexAexPTHrgx8Meta?.path ?? "playlists/:playlist_id()",
    meta: indexAexPTHrgx8Meta || {},
    alias: indexAexPTHrgx8Meta?.alias || [],
    redirect: indexAexPTHrgx8Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93aPrRoO4QiyMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93aPrRoO4QiyMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93aPrRoO4QiyMeta || {},
    alias: _91media_id_93aPrRoO4QiyMeta?.alias || [],
    redirect: _91media_id_93aPrRoO4QiyMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexmAFjunJF9HMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexmAFjunJF9HMeta?.path ?? "playlists",
    meta: indexmAFjunJF9HMeta || {},
    alias: indexmAFjunJF9HMeta?.alias || [],
    redirect: indexmAFjunJF9HMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsXI0WmY1mZSMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsXI0WmY1mZSMeta?.path ?? "private-sessions",
    meta: private_45sessionsXI0WmY1mZSMeta || {},
    alias: private_45sessionsXI0WmY1mZSMeta?.alias || [],
    redirect: private_45sessionsXI0WmY1mZSMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingspH2rLnTKc8Meta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingspH2rLnTKc8Meta?.path ?? "recordings",
    meta: recordingspH2rLnTKc8Meta || {},
    alias: recordingspH2rLnTKc8Meta?.alias || [],
    redirect: recordingspH2rLnTKc8Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsAXEU7JNBW4Meta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsAXEU7JNBW4Meta?.path ?? "reviews",
    meta: reviewsAXEU7JNBW4Meta || {},
    alias: reviewsAXEU7JNBW4Meta?.alias || [],
    redirect: reviewsAXEU7JNBW4Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexcW8E1ta5n0Meta?.name ?? "buy-product-product_id",
    path: indexcW8E1ta5n0Meta?.path ?? "/buy/product/:product_id()",
    meta: indexcW8E1ta5n0Meta || {},
    alias: indexcW8E1ta5n0Meta?.alias || [],
    redirect: indexcW8E1ta5n0Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirm1sscMtZdKFMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirm1sscMtZdKFMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirm1sscMtZdKFMeta || {},
    alias: confirm1sscMtZdKFMeta?.alias || [],
    redirect: confirm1sscMtZdKFMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirm9lreFnKhCRMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirm9lreFnKhCRMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirm9lreFnKhCRMeta || {},
    alias: confirm9lreFnKhCRMeta?.alias || [],
    redirect: confirm9lreFnKhCRMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarPF08siiegbMeta?.name ?? "calendar",
    path: calendarPF08siiegbMeta?.path ?? "/calendar",
    meta: calendarPF08siiegbMeta || {},
    alias: calendarPF08siiegbMeta?.alias || [],
    redirect: calendarPF08siiegbMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatSll5i0H50bMeta?.name ?? "chat",
    path: chatSll5i0H50bMeta?.path ?? "/chat",
    meta: chatSll5i0H50bMeta || {},
    alias: chatSll5i0H50bMeta?.alias || [],
    redirect: chatSll5i0H50bMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93QjLRzdWVbSMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93QjLRzdWVbSMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93QjLRzdWVbSMeta || {},
    alias: _91group_id_93QjLRzdWVbSMeta?.alias || [],
    redirect: _91group_id_93QjLRzdWVbSMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutGTRZmJTElWMeta?.name ?? "community-groups-group_id-about",
    path: aboutGTRZmJTElWMeta?.path ?? "about",
    meta: aboutGTRZmJTElWMeta || {},
    alias: aboutGTRZmJTElWMeta?.alias || [],
    redirect: aboutGTRZmJTElWMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedb61uC56bX0Meta?.name ?? "community-groups-group_id-feed",
    path: feedb61uC56bX0Meta?.path ?? "feed",
    meta: feedb61uC56bX0Meta || {},
    alias: feedb61uC56bX0Meta?.alias || [],
    redirect: feedb61uC56bX0Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersnIY7RN5fRMMeta?.name ?? "community-groups-group_id-members",
    path: membersnIY7RN5fRMMeta?.path ?? "members",
    meta: membersnIY7RN5fRMMeta || {},
    alias: membersnIY7RN5fRMMeta?.alias || [],
    redirect: membersnIY7RN5fRMMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editVq8DO5iaycMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editVq8DO5iaycMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editVq8DO5iaycMeta || {},
    alias: community_45profile_45editVq8DO5iaycMeta?.alias || [],
    redirect: community_45profile_45editVq8DO5iaycMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Dto1XExhC0Meta?.name ?? "community-profile-id",
    path: _91id_93Dto1XExhC0Meta?.path ?? "/community-profile/:id()",
    meta: _91id_93Dto1XExhC0Meta || {},
    alias: _91id_93Dto1XExhC0Meta?.alias || [],
    redirect: _91id_93Dto1XExhC0Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityRHCVFeJlKPMeta?.name ?? "community",
    path: communityRHCVFeJlKPMeta?.path ?? "/community",
    meta: communityRHCVFeJlKPMeta || {},
    alias: communityRHCVFeJlKPMeta?.alias || [],
    redirect: communityRHCVFeJlKPMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93KUD5YcS11MMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93KUD5YcS11MMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93KUD5YcS11MMeta || {},
    alias: _91uuid_93KUD5YcS11MMeta?.alias || [],
    redirect: _91uuid_93KUD5YcS11MMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93nIaoWPMECkMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93nIaoWPMECkMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93nIaoWPMECkMeta || {},
    alias: _91unique_id_93nIaoWPMECkMeta?.alias || [],
    redirect: _91unique_id_93nIaoWPMECkMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardwQWKd2uvEXMeta?.name ?? "dashboard",
    path: dashboardwQWKd2uvEXMeta?.path ?? "/dashboard",
    meta: dashboardwQWKd2uvEXMeta || {},
    alias: dashboardwQWKd2uvEXMeta?.alias || [],
    redirect: dashboardwQWKd2uvEXMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexjweqlpjybtMeta?.name ?? "event-details-event_id",
    path: indexjweqlpjybtMeta?.path ?? "/event/details/:event_id()",
    meta: indexjweqlpjybtMeta || {},
    alias: indexjweqlpjybtMeta?.alias || [],
    redirect: indexjweqlpjybtMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutWK5zB2e3nAMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutWK5zB2e3nAMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutWK5zB2e3nAMeta || {},
    alias: checkoutWK5zB2e3nAMeta?.alias || [],
    redirect: checkoutWK5zB2e3nAMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productzaruv8fDGdMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productzaruv8fDGdMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productzaruv8fDGdMeta || {},
    alias: select_45productzaruv8fDGdMeta?.alias || [],
    redirect: select_45productzaruv8fDGdMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsmUMzRFqLoWMeta?.name ?? "events",
    path: eventsmUMzRFqLoWMeta?.path ?? "/events",
    meta: eventsmUMzRFqLoWMeta || {},
    alias: eventsmUMzRFqLoWMeta?.alias || [],
    redirect: eventsmUMzRFqLoWMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93JRjqgzya25Meta?.name ?? "gifts-uuid",
    path: _91uuid_93JRjqgzya25Meta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93JRjqgzya25Meta || {},
    alias: _91uuid_93JRjqgzya25Meta?.alias || [],
    redirect: _91uuid_93JRjqgzya25Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: index9yG4ughAGTMeta?.name ?? "gifts",
    path: index9yG4ughAGTMeta?.path ?? "/gifts",
    meta: index9yG4ughAGTMeta || {},
    alias: index9yG4ughAGTMeta?.alias || [],
    redirect: index9yG4ughAGTMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93f9yWxwQYDJMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93f9yWxwQYDJMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93f9yWxwQYDJMeta || {},
    alias: _91invitation_id_93f9yWxwQYDJMeta?.alias || [],
    redirect: _91invitation_id_93f9yWxwQYDJMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93QGL4hWX27IMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93QGL4hWX27IMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93QGL4hWX27IMeta || {},
    alias: _91product_id_93QGL4hWX27IMeta?.alias || [],
    redirect: _91product_id_93QGL4hWX27IMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: index6IJfbaoxUaMeta?.name ?? "index",
    path: index6IJfbaoxUaMeta?.path ?? "/",
    meta: index6IJfbaoxUaMeta || {},
    alias: index6IJfbaoxUaMeta?.alias || [],
    redirect: index6IJfbaoxUaMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93qkp2TsypvUMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93qkp2TsypvUMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93qkp2TsypvUMeta || {},
    alias: _91invitation_unique_id_93qkp2TsypvUMeta?.alias || [],
    redirect: _91invitation_unique_id_93qkp2TsypvUMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinKiUY2qRdLlMeta?.name ?? "join",
    path: joinKiUY2qRdLlMeta?.path ?? "/join",
    meta: joinKiUY2qRdLlMeta || {},
    alias: joinKiUY2qRdLlMeta?.alias || [],
    redirect: joinKiUY2qRdLlMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginQFrK1yAWHFMeta?.name ?? "login",
    path: loginQFrK1yAWHFMeta?.path ?? "/login",
    meta: loginQFrK1yAWHFMeta || {},
    alias: loginQFrK1yAWHFMeta?.alias || [],
    redirect: loginQFrK1yAWHFMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutHc9wm0Av5NMeta?.name ?? "logout",
    path: logoutHc9wm0Av5NMeta?.path ?? "/logout",
    meta: logoutHc9wm0Av5NMeta || {},
    alias: logoutHc9wm0Av5NMeta?.alias || [],
    redirect: logoutHc9wm0Av5NMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93JTlAizOp8BMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93JTlAizOp8BMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93JTlAizOp8BMeta || {},
    alias: _91meeting_type_slug_93JTlAizOp8BMeta?.alias || [],
    redirect: _91meeting_type_slug_93JTlAizOp8BMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93sKrsmNeooPMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93sKrsmNeooPMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93sKrsmNeooPMeta || {},
    alias: _91meeting_unique_id_93sKrsmNeooPMeta?.alias || [],
    redirect: _91meeting_unique_id_93sKrsmNeooPMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93YP4z1JDwwcMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93YP4z1JDwwcMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93YP4z1JDwwcMeta || {},
    alias: _91meeting_unique_id_93YP4z1JDwwcMeta?.alias || [],
    redirect: _91meeting_unique_id_93YP4z1JDwwcMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesnP0NyeSSfTMeta?.name ?? "my-favorites",
    path: my_45favoritesnP0NyeSSfTMeta?.path ?? "/my-favorites",
    meta: my_45favoritesnP0NyeSSfTMeta || {},
    alias: my_45favoritesnP0NyeSSfTMeta?.alias || [],
    redirect: my_45favoritesnP0NyeSSfTMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosi3B1jFWheqMeta?.name ?? "my-studios",
    path: my_45studiosi3B1jFWheqMeta?.path ?? "/my-studios",
    meta: my_45studiosi3B1jFWheqMeta || {},
    alias: my_45studiosi3B1jFWheqMeta?.alias || [],
    redirect: my_45studiosi3B1jFWheqMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optina9XeYPs4xiMeta?.name ?? "optin",
    path: optina9XeYPs4xiMeta?.path ?? "/optin",
    meta: optina9XeYPs4xiMeta || {},
    alias: optina9XeYPs4xiMeta?.alias || [],
    redirect: optina9XeYPs4xiMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93fBZpfVNX5qMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93fBZpfVNX5qMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93fBZpfVNX5qMeta || {},
    alias: _91episode_id_93fBZpfVNX5qMeta?.alias || [],
    redirect: _91episode_id_93fBZpfVNX5qMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexUpoVD9bPY5Meta?.name ?? "podcasts-podcast_id",
    path: indexUpoVD9bPY5Meta?.path ?? "/podcasts/:podcast_id()",
    meta: indexUpoVD9bPY5Meta || {},
    alias: indexUpoVD9bPY5Meta?.alias || [],
    redirect: indexUpoVD9bPY5Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGllZf06CQdMeta?.name ?? "podcasts",
    path: indexGllZf06CQdMeta?.path ?? "/podcasts",
    meta: indexGllZf06CQdMeta || {},
    alias: indexGllZf06CQdMeta?.alias || [],
    redirect: indexGllZf06CQdMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93Xn5glodteBMeta?.name ?? "product-product_id",
    path: _91product_id_93Xn5glodteBMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93Xn5glodteBMeta || {},
    alias: _91product_id_93Xn5glodteBMeta?.alias || [],
    redirect: _91product_id_93Xn5glodteBMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouts9Irk4NNVLMeta?.name ?? "product-product_id-about",
    path: abouts9Irk4NNVLMeta?.path ?? "about",
    meta: abouts9Irk4NNVLMeta || {},
    alias: abouts9Irk4NNVLMeta?.alias || [],
    redirect: abouts9Irk4NNVLMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentMhn1o26oq1Meta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentMhn1o26oq1Meta?.path ?? "digital-download-content",
    meta: digital_45download_45contentMhn1o26oq1Meta || {},
    alias: digital_45download_45contentMhn1o26oq1Meta?.alias || [],
    redirect: digital_45download_45contentMhn1o26oq1Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventstTXMqNF7cCMeta?.name ?? "product-product_id-events",
    path: eventstTXMqNF7cCMeta?.path ?? "events",
    meta: eventstTXMqNF7cCMeta || {},
    alias: eventstTXMqNF7cCMeta?.alias || [],
    redirect: eventstTXMqNF7cCMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93EzBJJlfVo2Meta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93EzBJJlfVo2Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93EzBJJlfVo2Meta || {},
    alias: _91media_id_93EzBJJlfVo2Meta?.alias || [],
    redirect: _91media_id_93EzBJJlfVo2Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleuYxczmTF0nMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleuYxczmTF0nMeta?.path ?? "free-sample",
    meta: free_45sampleuYxczmTF0nMeta || {},
    alias: free_45sampleuYxczmTF0nMeta?.alias || [],
    redirect: free_45sampleuYxczmTF0nMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsuUxqM2EMnRMeta?.name ?? "product-product_id-included-products",
    path: included_45productsuUxqM2EMnRMeta?.path ?? "included-products",
    meta: included_45productsuUxqM2EMnRMeta || {},
    alias: included_45productsuUxqM2EMnRMeta?.alias || [],
    redirect: included_45productsuUxqM2EMnRMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93HE6E24KSgmMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93HE6E24KSgmMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93HE6E24KSgmMeta || {},
    alias: _91media_id_93HE6E24KSgmMeta?.alias || [],
    redirect: _91media_id_93HE6E24KSgmMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewCfTnJ3ocyNMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewCfTnJ3ocyNMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewCfTnJ3ocyNMeta || {},
    alias: viewCfTnJ3ocyNMeta?.alias || [],
    redirect: viewCfTnJ3ocyNMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index6i0aiJKdDDMeta?.name ?? "product-product_id-lessons",
    path: index6i0aiJKdDDMeta?.path ?? "lessons",
    meta: index6i0aiJKdDDMeta || {},
    alias: index6i0aiJKdDDMeta?.alias || [],
    redirect: index6i0aiJKdDDMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93WfqUaMbKnsMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93WfqUaMbKnsMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93WfqUaMbKnsMeta || {},
    alias: _91media_id_93WfqUaMbKnsMeta?.alias || [],
    redirect: _91media_id_93WfqUaMbKnsMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexvzX1J3k3DoMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexvzX1J3k3DoMeta?.path ?? "playlists/:playlist_id()",
    meta: indexvzX1J3k3DoMeta || {},
    alias: indexvzX1J3k3DoMeta?.alias || [],
    redirect: indexvzX1J3k3DoMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93GepfzlWOSDMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93GepfzlWOSDMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93GepfzlWOSDMeta || {},
    alias: _91media_id_93GepfzlWOSDMeta?.alias || [],
    redirect: _91media_id_93GepfzlWOSDMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index9Q7LTDYIlqMeta?.name ?? "product-product_id-playlists",
    path: index9Q7LTDYIlqMeta?.path ?? "playlists",
    meta: index9Q7LTDYIlqMeta || {},
    alias: index9Q7LTDYIlqMeta?.alias || [],
    redirect: index9Q7LTDYIlqMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsGKFBMOX1qkMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsGKFBMOX1qkMeta?.path ?? "private-sessions",
    meta: private_45sessionsGKFBMOX1qkMeta || {},
    alias: private_45sessionsGKFBMOX1qkMeta?.alias || [],
    redirect: private_45sessionsGKFBMOX1qkMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsZw385OMPwKMeta?.name ?? "product-product_id-recordings",
    path: recordingsZw385OMPwKMeta?.path ?? "recordings",
    meta: recordingsZw385OMPwKMeta || {},
    alias: recordingsZw385OMPwKMeta?.alias || [],
    redirect: recordingsZw385OMPwKMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsUSlJTEBhpYMeta?.name ?? "product-product_id-reviews",
    path: reviewsUSlJTEBhpYMeta?.path ?? "reviews",
    meta: reviewsUSlJTEBhpYMeta || {},
    alias: reviewsUSlJTEBhpYMeta?.alias || [],
    redirect: reviewsUSlJTEBhpYMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexSQuATSF23FMeta?.name ?? "product",
    path: indexSQuATSF23FMeta?.path ?? "/product",
    meta: indexSQuATSF23FMeta || {},
    alias: indexSQuATSF23FMeta?.alias || [],
    redirect: indexSQuATSF23FMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: index5Qp9RRgSsTMeta?.name ?? "profile",
    path: index5Qp9RRgSsTMeta?.path ?? "/profile",
    meta: index5Qp9RRgSsTMeta || {},
    alias: index5Qp9RRgSsTMeta?.alias || [],
    redirect: index5Qp9RRgSsTMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesaQMeCkKBAiMeta?.name ?? "profile-purchases",
    path: purchasesaQMeCkKBAiMeta?.path ?? "/profile/purchases",
    meta: purchasesaQMeCkKBAiMeta || {},
    alias: purchasesaQMeCkKBAiMeta?.alias || [],
    redirect: purchasesaQMeCkKBAiMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsv3zPWzNIaaMeta?.name ?? "profile-redemptions",
    path: redemptionsv3zPWzNIaaMeta?.path ?? "/profile/redemptions",
    meta: redemptionsv3zPWzNIaaMeta || {},
    alias: redemptionsv3zPWzNIaaMeta?.alias || [],
    redirect: redemptionsv3zPWzNIaaMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93idJs1LxCyuMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93idJs1LxCyuMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93idJs1LxCyuMeta || {},
    alias: _91quiz_id_93idJs1LxCyuMeta?.alias || [],
    redirect: _91quiz_id_93idJs1LxCyuMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93mMEi0JwqhsMeta?.name ?? "reset-password-uid-token",
    path: _91token_93mMEi0JwqhsMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93mMEi0JwqhsMeta || {},
    alias: _91token_93mMEi0JwqhsMeta?.alias || [],
    redirect: _91token_93mMEi0JwqhsMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetD1ObNJ2V6CMeta?.name ?? "reset",
    path: resetD1ObNJ2V6CMeta?.path ?? "/reset",
    meta: resetD1ObNJ2V6CMeta || {},
    alias: resetD1ObNJ2V6CMeta?.alias || [],
    redirect: resetD1ObNJ2V6CMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopyA9PAPBEe4Meta?.name ?? "shop",
    path: shopyA9PAPBEe4Meta?.path ?? "/shop",
    meta: shopyA9PAPBEe4Meta || {},
    alias: shopyA9PAPBEe4Meta?.alias || [],
    redirect: shopyA9PAPBEe4Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupiK6AMmwHUbMeta?.name ?? "signup",
    path: signupiK6AMmwHUbMeta?.path ?? "/signup",
    meta: signupiK6AMmwHUbMeta || {},
    alias: signupiK6AMmwHUbMeta?.alias || [],
    redirect: signupiK6AMmwHUbMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveoK8K7dEB92Meta?.name ?? "streaming-event_id-live",
    path: liveoK8K7dEB92Meta?.path ?? "/streaming/:event_id()/live",
    meta: liveoK8K7dEB92Meta || {},
    alias: liveoK8K7dEB92Meta?.alias || [],
    redirect: liveoK8K7dEB92Meta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipslb19365bWLMeta?.name ?? "tips",
    path: tipslb19365bWLMeta?.path ?? "/tips",
    meta: tipslb19365bWLMeta || {},
    alias: tipslb19365bWLMeta?.alias || [],
    redirect: tipslb19365bWLMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_935PmXpwyttQMeta?.name ?? "waiver-uuid",
    path: _91uuid_935PmXpwyttQMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_935PmXpwyttQMeta || {},
    alias: _91uuid_935PmXpwyttQMeta?.alias || [],
    redirect: _91uuid_935PmXpwyttQMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactIg30hovC2CMeta?.name ?? "widgets-calendars-compact",
    path: compactIg30hovC2CMeta?.path ?? "/widgets/calendars/compact",
    meta: compactIg30hovC2CMeta || {},
    alias: compactIg30hovC2CMeta?.alias || [],
    redirect: compactIg30hovC2CMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full0cXP5NKy6eMeta?.name ?? "widgets-calendars-full",
    path: full0cXP5NKy6eMeta?.path ?? "/widgets/calendars/full",
    meta: full0cXP5NKy6eMeta || {},
    alias: full0cXP5NKy6eMeta?.alias || [],
    redirect: full0cXP5NKy6eMeta?.redirect,
    component: () => import("/tmp/build_e43f378b/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]